/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public/route'
import { Route as ProtectedRouteImport } from './routes/_protected/route'
import { Route as ProtectedIndexImport } from './routes/_protected/index'
import { Route as PublicResetPasswordImport } from './routes/_public/reset-password'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as PublicForgotPasswordImport } from './routes/_public/forgot-password'
import { Route as ProtectedVehiclesIndexImport } from './routes/_protected/vehicles/index'
import { Route as ProtectedServicesIndexImport } from './routes/_protected/services/index'
import { Route as ProtectedPlanningIndexImport } from './routes/_protected/planning/index'
import { Route as ProtectedMatchingIndexImport } from './routes/_protected/matching/index'
import { Route as ProtectedMarketingIndexImport } from './routes/_protected/marketing/index'
import { Route as ProtectedCustomersIndexImport } from './routes/_protected/customers/index'
import { Route as ProtectedApplicationIndexImport } from './routes/_protected/application/index'
import { Route as ProtectedVehiclesIdImport } from './routes/_protected/vehicles/$id'
import { Route as ProtectedServicerequestIdImport } from './routes/_protected/service_request/$id'
import { Route as ProtectedNewsIdImport } from './routes/_protected/news/$id'
import { Route as ProtectedEventIdImport } from './routes/_protected/event/$id'
import { Route as ProtectedCustomersIdImport } from './routes/_protected/customers/$id'

// Create/Update Routes

const PublicRouteRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRouteRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedIndexRoute = ProtectedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const PublicResetPasswordRoute = PublicResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRouteRoute,
} as any)

const PublicLoginRoute = PublicLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)

const PublicForgotPasswordRoute = PublicForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRouteRoute,
} as any)

const ProtectedVehiclesIndexRoute = ProtectedVehiclesIndexImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedServicesIndexRoute = ProtectedServicesIndexImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedPlanningIndexRoute = ProtectedPlanningIndexImport.update({
  id: '/planning/',
  path: '/planning/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedMatchingIndexRoute = ProtectedMatchingIndexImport.update({
  id: '/matching/',
  path: '/matching/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedMarketingIndexRoute = ProtectedMarketingIndexImport.update({
  id: '/marketing/',
  path: '/marketing/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedCustomersIndexRoute = ProtectedCustomersIndexImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedApplicationIndexRoute = ProtectedApplicationIndexImport.update({
  id: '/application/',
  path: '/application/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedVehiclesIdRoute = ProtectedVehiclesIdImport.update({
  id: '/vehicles/$id',
  path: '/vehicles/$id',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedServicerequestIdRoute = ProtectedServicerequestIdImport.update({
  id: '/service_request/$id',
  path: '/service_request/$id',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedNewsIdRoute = ProtectedNewsIdImport.update({
  id: '/news/$id',
  path: '/news/$id',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedEventIdRoute = ProtectedEventIdImport.update({
  id: '/event/$id',
  path: '/event/$id',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedCustomersIdRoute = ProtectedCustomersIdImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordImport
      parentRoute: typeof PublicRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicRouteImport
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordImport
      parentRoute: typeof PublicRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/customers/$id': {
      id: '/_protected/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof ProtectedCustomersIdImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/event/$id': {
      id: '/_protected/event/$id'
      path: '/event/$id'
      fullPath: '/event/$id'
      preLoaderRoute: typeof ProtectedEventIdImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/news/$id': {
      id: '/_protected/news/$id'
      path: '/news/$id'
      fullPath: '/news/$id'
      preLoaderRoute: typeof ProtectedNewsIdImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/service_request/$id': {
      id: '/_protected/service_request/$id'
      path: '/service_request/$id'
      fullPath: '/service_request/$id'
      preLoaderRoute: typeof ProtectedServicerequestIdImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/vehicles/$id': {
      id: '/_protected/vehicles/$id'
      path: '/vehicles/$id'
      fullPath: '/vehicles/$id'
      preLoaderRoute: typeof ProtectedVehiclesIdImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/application/': {
      id: '/_protected/application/'
      path: '/application'
      fullPath: '/application'
      preLoaderRoute: typeof ProtectedApplicationIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/customers/': {
      id: '/_protected/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof ProtectedCustomersIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/marketing/': {
      id: '/_protected/marketing/'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof ProtectedMarketingIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/matching/': {
      id: '/_protected/matching/'
      path: '/matching'
      fullPath: '/matching'
      preLoaderRoute: typeof ProtectedMatchingIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/planning/': {
      id: '/_protected/planning/'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof ProtectedPlanningIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/services/': {
      id: '/_protected/services/'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ProtectedServicesIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/vehicles/': {
      id: '/_protected/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof ProtectedVehiclesIndexImport
      parentRoute: typeof ProtectedRouteImport
    }
  }
}

// Create and export the route tree

interface ProtectedRouteRouteChildren {
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedCustomersIdRoute: typeof ProtectedCustomersIdRoute
  ProtectedEventIdRoute: typeof ProtectedEventIdRoute
  ProtectedNewsIdRoute: typeof ProtectedNewsIdRoute
  ProtectedServicerequestIdRoute: typeof ProtectedServicerequestIdRoute
  ProtectedVehiclesIdRoute: typeof ProtectedVehiclesIdRoute
  ProtectedApplicationIndexRoute: typeof ProtectedApplicationIndexRoute
  ProtectedCustomersIndexRoute: typeof ProtectedCustomersIndexRoute
  ProtectedMarketingIndexRoute: typeof ProtectedMarketingIndexRoute
  ProtectedMatchingIndexRoute: typeof ProtectedMatchingIndexRoute
  ProtectedPlanningIndexRoute: typeof ProtectedPlanningIndexRoute
  ProtectedServicesIndexRoute: typeof ProtectedServicesIndexRoute
  ProtectedVehiclesIndexRoute: typeof ProtectedVehiclesIndexRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedCustomersIdRoute: ProtectedCustomersIdRoute,
  ProtectedEventIdRoute: ProtectedEventIdRoute,
  ProtectedNewsIdRoute: ProtectedNewsIdRoute,
  ProtectedServicerequestIdRoute: ProtectedServicerequestIdRoute,
  ProtectedVehiclesIdRoute: ProtectedVehiclesIdRoute,
  ProtectedApplicationIndexRoute: ProtectedApplicationIndexRoute,
  ProtectedCustomersIndexRoute: ProtectedCustomersIndexRoute,
  ProtectedMarketingIndexRoute: ProtectedMarketingIndexRoute,
  ProtectedMatchingIndexRoute: ProtectedMatchingIndexRoute,
  ProtectedPlanningIndexRoute: ProtectedPlanningIndexRoute,
  ProtectedServicesIndexRoute: ProtectedServicesIndexRoute,
  ProtectedVehiclesIndexRoute: ProtectedVehiclesIndexRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof PublicRouteRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/': typeof ProtectedIndexRoute
  '/customers/$id': typeof ProtectedCustomersIdRoute
  '/event/$id': typeof ProtectedEventIdRoute
  '/news/$id': typeof ProtectedNewsIdRoute
  '/service_request/$id': typeof ProtectedServicerequestIdRoute
  '/vehicles/$id': typeof ProtectedVehiclesIdRoute
  '/application': typeof ProtectedApplicationIndexRoute
  '/customers': typeof ProtectedCustomersIndexRoute
  '/marketing': typeof ProtectedMarketingIndexRoute
  '/matching': typeof ProtectedMatchingIndexRoute
  '/planning': typeof ProtectedPlanningIndexRoute
  '/services': typeof ProtectedServicesIndexRoute
  '/vehicles': typeof ProtectedVehiclesIndexRoute
}

export interface FileRoutesByTo {
  '': typeof PublicRouteRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/': typeof ProtectedIndexRoute
  '/customers/$id': typeof ProtectedCustomersIdRoute
  '/event/$id': typeof ProtectedEventIdRoute
  '/news/$id': typeof ProtectedNewsIdRoute
  '/service_request/$id': typeof ProtectedServicerequestIdRoute
  '/vehicles/$id': typeof ProtectedVehiclesIdRoute
  '/application': typeof ProtectedApplicationIndexRoute
  '/customers': typeof ProtectedCustomersIndexRoute
  '/marketing': typeof ProtectedMarketingIndexRoute
  '/matching': typeof ProtectedMatchingIndexRoute
  '/planning': typeof ProtectedPlanningIndexRoute
  '/services': typeof ProtectedServicesIndexRoute
  '/vehicles': typeof ProtectedVehiclesIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/customers/$id': typeof ProtectedCustomersIdRoute
  '/_protected/event/$id': typeof ProtectedEventIdRoute
  '/_protected/news/$id': typeof ProtectedNewsIdRoute
  '/_protected/service_request/$id': typeof ProtectedServicerequestIdRoute
  '/_protected/vehicles/$id': typeof ProtectedVehiclesIdRoute
  '/_protected/application/': typeof ProtectedApplicationIndexRoute
  '/_protected/customers/': typeof ProtectedCustomersIndexRoute
  '/_protected/marketing/': typeof ProtectedMarketingIndexRoute
  '/_protected/matching/': typeof ProtectedMatchingIndexRoute
  '/_protected/planning/': typeof ProtectedPlanningIndexRoute
  '/_protected/services/': typeof ProtectedServicesIndexRoute
  '/_protected/vehicles/': typeof ProtectedVehiclesIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/'
    | '/customers/$id'
    | '/event/$id'
    | '/news/$id'
    | '/service_request/$id'
    | '/vehicles/$id'
    | '/application'
    | '/customers'
    | '/marketing'
    | '/matching'
    | '/planning'
    | '/services'
    | '/vehicles'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/'
    | '/customers/$id'
    | '/event/$id'
    | '/news/$id'
    | '/service_request/$id'
    | '/vehicles/$id'
    | '/application'
    | '/customers'
    | '/marketing'
    | '/matching'
    | '/planning'
    | '/services'
    | '/vehicles'
  id:
    | '__root__'
    | '/_protected'
    | '/_public'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_protected/'
    | '/_protected/customers/$id'
    | '/_protected/event/$id'
    | '/_protected/news/$id'
    | '/_protected/service_request/$id'
    | '/_protected/vehicles/$id'
    | '/_protected/application/'
    | '/_protected/customers/'
    | '/_protected/marketing/'
    | '/_protected/matching/'
    | '/_protected/planning/'
    | '/_protected/services/'
    | '/_protected/vehicles/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_protected",
        "/_public"
      ]
    },
    "/_protected": {
      "filePath": "_protected/route.tsx",
      "children": [
        "/_protected/",
        "/_protected/customers/$id",
        "/_protected/event/$id",
        "/_protected/news/$id",
        "/_protected/service_request/$id",
        "/_protected/vehicles/$id",
        "/_protected/application/",
        "/_protected/customers/",
        "/_protected/marketing/",
        "/_protected/matching/",
        "/_protected/planning/",
        "/_protected/services/",
        "/_protected/vehicles/"
      ]
    },
    "/_public": {
      "filePath": "_public/route.tsx",
      "children": [
        "/_public/forgot-password",
        "/_public/login",
        "/_public/reset-password"
      ]
    },
    "/_public/forgot-password": {
      "filePath": "_public/forgot-password.tsx",
      "parent": "/_public"
    },
    "/_public/login": {
      "filePath": "_public/login.tsx",
      "parent": "/_public"
    },
    "/_public/reset-password": {
      "filePath": "_public/reset-password.tsx",
      "parent": "/_public"
    },
    "/_protected/": {
      "filePath": "_protected/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/customers/$id": {
      "filePath": "_protected/customers/$id.tsx",
      "parent": "/_protected"
    },
    "/_protected/event/$id": {
      "filePath": "_protected/event/$id.tsx",
      "parent": "/_protected"
    },
    "/_protected/news/$id": {
      "filePath": "_protected/news/$id.tsx",
      "parent": "/_protected"
    },
    "/_protected/service_request/$id": {
      "filePath": "_protected/service_request/$id.tsx",
      "parent": "/_protected"
    },
    "/_protected/vehicles/$id": {
      "filePath": "_protected/vehicles/$id.tsx",
      "parent": "/_protected"
    },
    "/_protected/application/": {
      "filePath": "_protected/application/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/customers/": {
      "filePath": "_protected/customers/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/marketing/": {
      "filePath": "_protected/marketing/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/matching/": {
      "filePath": "_protected/matching/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/planning/": {
      "filePath": "_protected/planning/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/services/": {
      "filePath": "_protected/services/index.tsx",
      "parent": "/_protected"
    },
    "/_protected/vehicles/": {
      "filePath": "_protected/vehicles/index.tsx",
      "parent": "/_protected"
    }
  }
}
ROUTE_MANIFEST_END */
